<!--
 * @Description: 
 * @Author: zml
 * @Date: 2023-03-21 11:49:51
 * @LastEditors: zml
 * @LastEditTime: 2025-08-18 09:34:08
-->
<template>
  <el-dialog @close="close" :visible="visible" :close-on-click-modal="false" width="600px" center append-to-body>
    <div class="reset-title">
      <div class="title">{{$t('GA.resetPasswords')}}</div>
    </div>
    <div class="form-box">
      <el-form :model="form" ref="form" label-position="top" label-width="180px" :rules="rules">
        <el-form-item prop="email" :label="$t('GA.emailAddress') + ':'" required>
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item prop="code" :label="$t('GA.verifyCode') + ':'" required>
          <div style="display:flex">
            <el-input v-model="form.code"></el-input>
            <el-button class="get-code" @click="getEmailCode">{{ $hs("获取验证码","Send verification code","")}}</el-button>
          </div>
        </el-form-item>
        <el-form-item prop="password" :label="$t('GA.newPassword') + ':'" required>
          <el-input type="password" v-model="form.password"></el-input>
        </el-form-item>
        <el-form-item prop="password1" :label="$t('GA.confirmPassword') + ':'" required>
          <el-input type="password" v-model="form.password1"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="loginFun" class="btn">{{ $hs("提交","Preserve") }}</el-button>
      </span>
    </div>
  </el-dialog>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import {
  LoginMemberNoCode,
  UpdatePasswordByEmail,
  GetEmailValideCode
} from '@/api/login'
export default {
  name: 'resetPassModel',
  data() {
    return {
      visible: false,
      codeData: {},
      form: {
        email: '',
        code: '',
        password: '',
        password1: ''
      },
      rules: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState('operate', ['language']),
    ...mapState('user', ['userInfo'])
  },
  methods: {
    ...mapActions('user', ['set_userInfo']),
    open() {
      this.visible = true
    },
    close() {
      this.visible = false
      this.$refs.form.resetFields()
    },

    register() {
      this.close()
      this.$emit('register')
    },

    getEmailCode() {
      let regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
      if (regEmail.test(this.form.email)) {
        GetEmailValideCode({
          email: this.form.email,
          language: this.$hs('zh-Hans', 'en', 'es')
        })
          .then(res => {
            if (res.success) {
              this.$message.success(
                this.$hs(
                  '验证码已经发送到你的邮箱',
                  'The verification code has been sent to your email',
                  'El Código de verificación ha sido enviado a tu buzón'
                )
              )
            } else {
              this.$message.error(JSON.stringify(res.message))
            }
          })
          .catch(err => {
            this.$message.error(err)
          })
      } else {
        this.$message.warning(
          this.$hs(
            '请输入正确的邮箱',
            'Please enter the correct email address',
            'Introduzca el buzón correcto'
          )
        )
      }
    },

    // 登录
    loginFun() {
      let _this = this
      this.$refs.form.validate(values => {
        if (!values) return false
        UpdatePasswordByEmail(this.form)
          .then(res => {
            if (res.success) {
              _this.$message.success(
                _this.$hs('重置成功', 'Reset successful', 'Reinicio exitoso')
              )
              _this.close()
            }
          })
          .catch(err => {
            _this.$message.error(err)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-dialog__header) {
  text-align: left;
  padding: 0px;
  .el-dialog__headerbtn {
    z-index: 99;
  }
}
:deep(.el-dialog__body) {
  padding: 0 !important;
  .reset-title {
    height: 62px;

    .title {
      height: 62px;
      text-align: left;
      font-size: 24px;
      color: #222222;
      margin-left: 30px;
      padding-top: 30px;
      font-weight: 700;
    }
  }

  .form-box {
    padding: 0 30px;
  }

  .operation {
    padding: 0 40px 30px;
    font-size: 14px;
    color: #222222;
    display: flex;
    justify-content: space-between;
  }
}
:deep .el-form {
  .valide-code {
    .el-input {
      margin: 0 10px 0 0;
    }
    .el-form-item__content {
      display: flex;
    }
  }
}

.dialog-footer {
  display: flex;
  box-sizing: border-box;
  .btn {
    flex: 1;
    margin-bottom: 30px;
    margin-top: 20px;
    background-color: #ff0000;
    border-color: #ff0000;
  }
}

:deep(.el-form-item__error) {
  display: none;
}

:deep(.el-form-item) {
  margin-bottom: 15px !important;
}

.get-code {
  margin-left: 10px;
}
</style>